export const EJ_ITEMS_TAB_ID = "eJourney-Details";
export const EJ_APPROVERS_TAB_ID = "eJourney-Approvers";
export const EJ_COMMENTS_TAB_ID = "eJourney-Comments";